const DetailData = {
    //編集画面の表示用
    set: {
        brand: [],
        shops: [],
        like: [],
        user: [],
        subscription_count: 0,
        personalAndBasic: false,
        unitAndBasic: false,
        adminAndBasic: false,
        activeBasicBrand: false,
        personalAndShowRoom: false,
        unitAndShowRoom: false,
        basicAndShowRoom: false,
        showRoomAndBasic: false,

        isUserToEnd: true,
    },
}

export default DetailData
